/**
 * Created by
 * @author <yunishev@sotal.tv> Art Yunishev
 * on 28.04.2016.
 */

import React, {Component, PropTypes} from 'react';
import ReactDOM from 'react-dom';

import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';

import {Link} from 'react-router';
import ScrollArea from '../../../../ScrollArea';
import {VelocityComponent} from 'velocity-react';
import Tooltip from 'rc-tooltip';

import {StubFunc, getScroll} from '../../../../../utils';
import {FetchAssetById} from '../../../../../actions/asset/action-asset';
import {SetPlayer, OpenMessage, ShareRequestDone} from '../../../../../actions/common/actions-common';
import {SetSettingsState} from '../../../../../actions/common/actions-common';
import {AddToFavorites, RemoveFromFavorites} from '../../../../../actions/favorites/actions-favorites';
import {ACTIONS} from '../../../../../containers/Player';

import DivLoader from '../../../../DivLoader';
import Translate from '../../../../Translate';
import Ratings from '../../Widgets/Ratings';
import Persons from '../../Widgets/Persons';
import Share from '../../Widgets/Share';
import MultiscreenDevices from '../../Widgets/MultiscreenDevices';

import _get from 'lodash/get';
import _find from 'lodash/find';
import _filter from 'lodash/filter';

class MovieProfile extends Component {
  constructor(props) {
    super(props);

    this.state = {
      picture: `/images/${Config.white_skin ? 'white' : 'black'}/no-movie-poster.png`,
      streamUrl: '',
      isPlayerShowed: false,
      streamCategory: null,
      showUserDevices: false,
      hasYoutubeContent: null,
      hasYoutubeTrailer: null
    };
  }

  componentDidMount() {
    let youTube = {};

    this._fetchMovieAssetData(_get(this.props, 'movieId', null));

    if (this.props.movie.id) {
      this.props.share && this.props.share.inAir && !this._isNeedToPurchase() && setTimeout(() => {
        this._startPlayback('vod_hls');
      }, 650);

      youTube = this.__findYoutubeResource();

      lh.models.asset.methods
        .getPosterUrl(this.props.movie, {
          crop: {x: 185, y: 270},
          cache: false
        })
        .then((url) => {
          this.setState({picture: url});
        }, () => {
          this.setState({picture: `/images/${Config.white_skin ? 'white' : 'black'}/no-movie-poster.png`});
        });

      _get(Config, 'youtube.auto_playback_youtube', false) && youTube.hasYoutubeContent && !this._hasContent() && !this.props.playerIsDetached && setTimeout(() => {

        this._startPlayback('vod_youtube');
      }, 750);
    }
  }

  componentWillReceiveProps(newProps) {
    let newState = {};
    let youTube = {};

    if (this.props.movieId !== newProps.movieId) {
      this._stopPlayback();

      newState = {
        ...newState, ...{
          picture: `/images/${Config.white_skin ? 'white' : 'black'}/no-movie-poster.png`,
          streamCategory: null,
          showUserDevices: false
        }
      };

      this._fetchMovieAssetData(_get(newProps, 'movieId', null));
    }

    if (newProps.movie.id && newProps.share && newProps.share.asset_id === newProps.movie.id) {

      newProps.share.inAir && !this._isNeedToPurchase() && setTimeout(() => {
        this._startPlayback('vod_hls');
      }, 650);
    }

    if (newProps.movie.id && newProps.movie.id !== this.props.movie.id) {
      youTube = this.__findYoutubeResource(newProps);

      lh.models.asset.methods
        .getPosterUrl(newProps.movie, {
          crop: {x: 185, y: 270},
        })
        .then((url) => {
          this.setState({picture: url});
        }, () => {
          this.setState({picture: `/images/${Config.white_skin ? 'white' : 'black'}/no-movie-poster.png`});
        });

      _get(Config, 'youtube.auto_playback_youtube', false) && youTube.hasYoutubeContent && !this._hasContent(newProps) && !this.props.playerIsDetached && setTimeout(() => {

        this._startPlayback('vod_youtube');
      }, 750);
    }

    if (newProps.playerIsDetached) {

      newState.isPlayerShowed = false;
    }

    this.setState(newState);
  }

  componentWillUnmount() {

    this._stopPlayback();
  }

  _fetchMovieAssetData(movieId) {
    this.props.FetchAssetById(movieId, 'movie');

  };

  _hasTrailer() {

    return !!_find(this.props.movie.resources, (resource) => {

      return resource.type === 'stream' && resource.stream_type.indexOf('youtube') === -1 && resource.category === 'trailer';
    });
  }

  _hasContent(props = this.props) {

    return !!_find(props.movie.resources, (resource) => {

      return resource.type === 'stream' && resource.stream_type.indexOf('youtube') === -1 && !resource.category;
    });
  }

  _addToFavorites() {
    if (this.props.user.user === 'guest') {

      this.props.SetSettingsState({
        isShown: true,
        tabId: 'login',
        meta: {
          fromPosition: getScroll()[1]
        }
      });

      return;
    }

    this.props.AddToFavorites(this.props.movie.id);
  }

  _removeFromFavorites() {
    if (this.props.user.user === 'guest') {

      this.props.SetSettingsState({
        isShown: true,
        tabId: 'login',
        meta: {
          fromPosition: getScroll()[1]
        }
      });

      return;
    }

    this.props.RemoveFromFavorites(this.props.movie.id);
  }

  _startPlayback(type) {
    if (['vod_youtube', 'trailer_youtube'].indexOf(type) !== -1) {

      let category = type === 'trailer_youtube' ? 'trailer' : null;

      lh.models.viewAsset.methods.getMediaUrl(this.props.movie, category, {is_youtube: true})
        .then((stream)=> {
          this.setState({streamUrl: stream, isPlayerShowed: !this.props.playerIsDetached && true, streamCategory: type});

          this.props.SetPlayer({
            stream_url: stream,
            container: ReactDOM.findDOMNode(this),
            action: ACTIONS.OPEN,
            type: 'youtube',
            stream_type: type
          });
        }, this._processStreamError);

      return;
    }

    if (this.props.user.user === 'guest' && type !== 'trailer_hls') {

      this.props.SetSettingsState({
        isShown: true,
        tabId: 'login',
        meta: {
          fromPosition: getScroll()[1]
        }
      });

      return;
    }

    if (!this.props.movie.is_purchased && !this.props.movie.is_available && !this.props.movie.is_free && type !== 'trailer_hls') {

      this._showOffers();
      return;
    }

    if (type === 'trailer_hls') {
      lh.models.viewAsset.methods.getTrailerUrl(this.props.movie)
        .then((stream) => {

          this.setState({streamUrl: stream, isPlayerShowed: !this.props.playerIsDetached && true, streamCategory: 'trailer_hls'});

          this.props.SetPlayer({
            stream_url: stream,
            container: ReactDOM.findDOMNode(this),
            action: ACTIONS.OPEN,
            //type: 'clpp',
            type: 'rmp',
            stream_type: type,
            monitoring: {
              assetTitle: _get(this.props, 'movie.title'),
              assetID: _get(this.props, 'movie.id'),
              type: 'movie'
            },
            get_url_again_fn: lh.models.viewAsset.methods.getTrailerUrl.bind(this, this.props.movie)
          });
        }, this._processStreamError);

    } else if (type === 'vod_hls') {

      if (_get(this.props.user, 'data.is_blocked')) {
        this.setState({isPlayerShowed: !this.props.playerIsDetached && true});

        this.props.SetPlayer({
          stream_url: null,
          action: ACTIONS.BLOCK,
          container: ReactDOM.findDOMNode(this),
          type: 'blocker',
        });

        return;
      }

      if (this.props.movie.is_bookmark && !this.props.share) {
        this.props.OpenMessage({
          type: 'bookmark',
          asset_id: this.props.movie.id,
          onContinue: () => {
            lh.models.viewAsset.methods.getStreamUrl(this.props.movie)
              .then((stream) => {

                this.setState({streamUrl: stream, isPlayerShowed: !this.props.playerIsDetached && true, streamCategory: 'vod_hls'});

                this.props.SetPlayer({
                  asset_id: this.props.movie.id,
                  stream_url: stream,
                  position: this.props.movie.bookmark || 0,
                  container: ReactDOM.findDOMNode(this),
                  action: ACTIONS.OPEN,
                  //type: 'clpp',
                  type: 'rmp',
                  stream_type: type,
                  monitoring: {
                    assetTitle: _get(this.props, 'movie.title'),
                    assetID: _get(this.props, 'movie.id'),
                    type: 'movie'
                  },
                  get_url_again_fn: lh.models.viewAsset.methods.getStreamUrl.bind(this, this.props.movie)
                });
              }, this._processStreamError);
          },
          onStartOver: () => {
            lh.models.viewAsset.methods.getStreamUrl(this.props.movie)
              .then((stream) => {

                this.setState({streamUrl: stream, isPlayerShowed: !this.props.playerIsDetached && true, streamCategory: 'vod_hls'});

                this.props.SetPlayer({
                  asset_id: this.props.movie.id,
                  stream_url: stream,
                  container: ReactDOM.findDOMNode(this),
                  action: ACTIONS.OPEN,
                  //type: 'clpp',
                  type: 'rmp',
                  stream_type: type,
                  monitoring: {
                    assetTitle: _get(this.props, 'movie.title'),
                    assetID: _get(this.props, 'movie.id'),
                    type: 'movie'
                  },
                  get_url_again_fn: lh.models.viewAsset.methods.getStreamUrl.bind(this, this.props.movie)
                });
              }, this._processStreamError);
          }
        });

        return;
      }

      lh.models.viewAsset.methods.getStreamUrl(this.props.movie)
        .then((stream) => {

          this.setState({streamUrl: stream, isPlayerShowed: !this.props.playerIsDetached && true, streamCategory: 'vod_hls'});

          let position = null;
          if (this.props.share) {
            position = _get(this.props, 'share.position', null);

            this.props.ShareRequestDone(_get(this.props, 'share.asset_id', null));
          }

          this.props.SetPlayer({
            asset_id: this.props.movie.id,
            stream_url: stream,
            position: position,
            container: ReactDOM.findDOMNode(this),
            action: ACTIONS.OPEN,
            //type: 'clpp',
            type: 'rmp',
            stream_type: type,
            monitoring: {
              assetTitle: _get(this.props, 'movie.title'),
              assetID: _get(this.props, 'movie.id'),
              type: 'movie'
            },
            get_url_again_fn: lh.models.viewAsset.methods.getStreamUrl.bind(this, this.props.movie)
          });
        }, this._processStreamError);
    }
  }

  _stopPlayback() {

    this.setState({isPlayerShowed: false, streamCategory: null, streamUrl: null});

    this.props.SetPlayer({
      stream_url: '',
      container: null,
      action: ACTIONS.CLOSE,
      monitoring: null
    });
  }

  _toggleDevices(state) {
    if (this.props.user.user === 'guest') {

      this.props.SetSettingsState({
        isShown: true,
        tabId: 'login',
        meta: {
          fromPosition: getScroll()[1]
        }
      });

      return;
    }

    this.setState({showUserDevices: state});
  };

  _closeProfile() {

    this._stopPlayback();
    this.props.onClose();
  }

  _showOffers() {
    if (this.props.user.user === 'guest') {

      this.props.SetSettingsState({
        isShown: true,
        tabId: 'login',
        meta: {
          fromPosition: getScroll()[1]
        }
      });

      return;
    }

    this.props.OpenMessage({
      type: 'offers',
      asset_id: this.props.movie.id,
      actions: [
        {
          title: 'no_thanks',
          func: () => {
          }
        }
      ]
    });
  }

  __findYoutubeResource(props = this.props) {
    let newState = {
      hasYoutubeContent: false,
      hasYoutubeTrailer: false
    };

    let youtubeResources = _filter(_get(props, 'movie.resources', []), (resource) => {

      return resource.type === 'stream' && resource.stream_type.indexOf('youtube') !== -1;
    });

    if (youtubeResources) {

      youtubeResources.forEach((resource) => {

        let category = resource.category;

        newState['hasYoutube' + (!category ? 'Content' : 'Trailer')] = true;
      });

    }

    this.setState(newState);

    return newState;
  }

  _isNeedToPurchase(asset = this.props.movie) {

    return !asset.is_purchased && !asset.is_available && !asset.is_free;
  }

  _isYoutubePlayback() {

    return this.state.streamCategory && this.state.streamCategory.indexOf('youtube') !== -1;
  }

  _processStreamError = (reason) => {
    if (_get(reason, 'message') === 'subscriber blocked') {
      this.setState({isPlayerShowed: !this.props.playerIsDetached && true});

      this.props.SetPlayer({
        stream_url: null,
        action: ACTIONS.BLOCK,
        container: ReactDOM.findDOMNode(this),
        type: 'blocker',
      });
    } else if (_get(reason, 'message') === 'the requested content is not available in your geographical location') {
      this.setState({isPlayerShowed: !this.props.playerIsDetached && true});

      this.props.SetPlayer({
        stream_url: null,
        action: ACTIONS.GEO_BLOCK,
        container: ReactDOM.findDOMNode(this),
        type: 'geo-blocker',
      });
    } else {
      //TODO: SHOW ERROR CODE
      console.log('Failed:', reason);
    }
  };

  _renderOffers() {
    if (!this.props.movie.offers || !this.props.movie.offers.length) return <noscript />;

    if (this.props.movie.is_purchased) {

      return <noscript />;
    }

    if (!this.props.movie.is_available && this.props.movie.is_free) {

      return <div className="profile-bigtext"><Translate content="profile.offers.type.free" /></div>;
    }

    return this.props.movie.offers.map(function (offer, index) {

      if (offer.type === 'transactional') {
        if (_get(offer, 'right_params.duration') === 0) {
          offer._typeParsed = 'transactional-own';
        } else {
          offer._typeParsed = 'transactional-rent';
        }
      } else {
        offer._typeParsed = offer.type;
      }

      return (
        <div className="offer" key={'offer_' + offer.id + '_' + index}>
          <div className="offer-type color-grey">
            <Translate content={`profile.offers.type.${_get(offer, '_typeParsed', '_')}`} />
            {(offer.is_from_package) ?
              <Tooltip
                placement="top"
                destroyTooltipOnHide={true}
                overlay={
                  <div className="rc-tooltip rc-tooltip-placement-top block-note bg-black radius p-">
                    <Translate content="profile.movie.bundle" />: {offer.parent.title || ''}
                  </div>}>
                <i className="ml- ic ic-tickets"></i>
              </Tooltip>
              : ''}
          </div>
          <div className="offer-price pointer">
            <i className={`ic ic-currency-${_get(offer, 'billing_params.currency', '').toLowerCase()}`}></i>
            <span>{_get(offer, 'billing_params.price') / 100}</span>
            {(_get(offer, 'type') === 'subscription') ?
              ('/' + (_get(offer, 'right_params.duration') > 1 ?
              _get(offer, 'right_params.duration') + ' ' : '') + _get(offer, 'right_params.duration_unit') + '(s)')
              : ''}
          </div>
        </div>
      );
    });
  }

  render() {
    if (!_get(this.props, 'movie.id')) return <div className="profile movie-inf-example movie-inf-profile bg-black radius"><DivLoader loading={true} /></div>;

    return (<div className="profile movie-inf-example movie-inf-profile bg-black radius">
      <DivLoader loading={this.props.inProgress} />
      <VelocityComponent animation={{left: this.state.isPlayerShowed ? 0 : '-456px'}} duration={500}>
        <div className="movie-player bg-black"></div>
      </VelocityComponent>
      <VelocityComponent animation={{left: this.state.isPlayerShowed ? '271px' : 0}} duration={500}>
        <div className="profile-cols relative">
          <div className="block-2 relative">
            <div className="profile-poster slider-pause">
              <div className={"crow " + (this._hasContent() ? " hover pointer" : "") + " no-gutter"} onClick={this._hasContent() && this._startPlayback.bind(this, 'vod_hls')}>
                <img id="profile_poster" src={this.state.picture} alt="" />
                {this._hasContent() && <img src={`/images/${Config.white_skin ? 'white' : 'black'}/play.png`} style={{position: 'absolute', top: '50%', left: '50%', marginTop: '-30px', marginLeft: '-70px'}} />}
              </div>
            </div>
            <div className="player-back hover crow no-gutter"
                 style={{display: this.state.isPlayerShowed ? 'block' : 'none'}}
                 onClick={this._stopPlayback.bind(this)}>
              <i className="ic ic-chevron-left"></i>
            </div>
            {!!this.state.hasYoutubeContent && !this.state.isPlayerShowed && <a className="hover playback-youtube" href="javascript:void(0)" onClick={this._startPlayback.bind(this, 'vod_youtube')}>
              <i className="ic ic-youtube ic-32px"></i>
            </a>}
          </div>
          <div className="block-2">
            <div className="profile-descr pr">
              <div className="profile-title">
                {_get(this.props.movie, 'title', '')}
              </div>
              <div className="profile-subhead pv-">
                {`${_get(this.props.movie, 'year', 0)}, ${parseInt(_get(this.props.movie, 'duration', 0) / 60, 10)}`} <Translate content="profile.movie.min" />
              </div>
              <Ratings ratings={this.props.movie.ratings} />
              <ScrollArea
                speed={0.8}
                className="profile-text"
                horizontal={false}
                smoothScrolling={true}>
                <div>{_get(this.props.movie, 'description', '')}</div>
              </ScrollArea>
            </div>
          </div>
          <div className="block-2">
            <div className="profile-r pr">
              <ScrollArea
                speed={0.8}
                className="profile-persons"
                horizontal={false}
                smoothScrolling={true}>
                <div>
                  <Persons persons={this.props.movie.persons} />
                </div>
              </ScrollArea>
            </div>
          </div>
          <VelocityComponent animation={this.state.isPlayerShowed && this.state.streamCategory !== 'trailer_hls' ? 'fadeOut' : 'fadeIn' } duration={500}>
            <div className="block-1">
              { !this.props.movie.is_purchased && !this.props.movie.is_available &&
              <div className="profile-r pr purchase-container">
                <ScrollArea
                  speed={0.8}
                  className="offers-wrapper"
                  horizontal={false}
                  smoothScrolling={true}>
                  {this._renderOffers()}
                </ScrollArea>
                {!this.props.movie.is_free && <div className="purchase-ico mt hover" onClick={this._showOffers.bind(this)}>
                  <i className="ic ic-shopping-cart"></i>
                </div>}
              </div>}
            </div>
          </VelocityComponent>
          <VelocityComponent animation={this.state.isPlayerShowed ? 'fadeOut' : 'fadeIn' } duration={500}>
            <div className="block-1">
              <div className="profile-r">
                <div className="profile-actions pr">
                  {this._hasTrailer() &&
                  <div className="mt-">
                    <div className="color-grey pv-"><Translate content="profile.movie.trailer" /></div>
                    <div id="trailer"><a className="hover" onClick={this._startPlayback.bind(this, 'trailer_hls')}>
                      <i className="ic ic-vod-trailer ic-24px"></i>
                    </a></div>
                  </div>
                  }
                  {!!this.state.hasYoutubeTrailer &&
                  <div className="mt-">
                    <div className="color-grey pv-"><Translate content="profile.movie.youtube_trailer" /></div>
                    <div id="youtube trailer"><a className="hover" onClick={this._startPlayback.bind(this, 'trailer_youtube')}>
                      <i className="ic ic-youtube ic-24px"></i>
                    </a></div>
                  </div>
                  }
                  <div className="mt-">
                    <div className="color-grey pv-"><Translate content="profile.movie.related" /></div>
                    <div>
                      <Link to={'/related/' + this.props.movie.id} className="hover">
                        <i className="ic ic-vod-related ic-24px"></i>
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </VelocityComponent>
          <div className="block-1 col-last">
            <div className="profile-r">
              <div className="profile-actions pr">
                {!this.props.movie.is_favorite ?
                  <div>
                    <div className="color-grey pv-"><Translate content="profile.movie.fav_add" /></div>
                    <div id="favorite"><a className="hover" onClick={this._addToFavorites.bind(this)}>
                      <i className="ic ic-fav-in ic-18px"></i>
                    </a></div>
                  </div>
                  :
                  <div>
                    <div className="color-grey pv-"><Translate content="profile.movie.fav_remove" /></div>
                    <div id="favorite"><a className="hover" onClick={this._removeFromFavorites.bind(this)}>
                      <i className="ic ic-fav-in-fill ic-18px"></i>
                    </a></div>
                  </div>
                }
                {Config.multiscreen_allowed && !this._isYoutubePlayback() &&
                <div className="mt-">
                  <div className="color-grey pv-"><Translate content="profile.movie.multiscreen" /></div>
                  <div id="screen">
                    <a className="hover share-to-device" onClick={this._toggleDevices.bind(this, true)}>
                      <i className="ic ic-multiscreen ic-24px"></i>
                    </a>
                  </div>
                </div>
                }
                <div className="mt-">
                  <Share contentUrl={`${location.origin}/asset/${this.props.movie.id}`} />
                </div>
              </div>
            </div>
            {Config.multiscreen_allowed && !this._isYoutubePlayback() && <MultiscreenDevices asset={this.props.movie} show={this.state.showUserDevices} onClose={this._toggleDevices.bind(this, false)} />}
          </div>
        </div>
      </VelocityComponent>
      <a className="mw-close ico ico-close slider-resume pointer" onClick={this._closeProfile.bind(this)}></a>
    </div>);
  }
}

MovieProfile.propTypes = {
  movieId: PropTypes.number.isRequired,
  movie: PropTypes.object.isRequired,
  onClose: PropTypes.func.isRequired,
  inProgress: PropTypes.bool.isRequired
};

MovieProfile.defaultProps = {
  onClose: StubFunc.bind(this, 'onClose from Movie Profile')
};

const mapStateToProps = function ({assets, auth: {user}, common: {shares, player}}, ownProps) {
  let asset = _get(assets, _get(ownProps, 'movieId', null), {});
  let share = _get(shares, _get(ownProps, 'movieId', null));

  return {
    user: user,
    movie: asset,
    share: share,
    inProgress: !!asset._fetchInProgress,
    playerIsDetached: !!player.isDetached
  }
};

const mapDispatchToProps = function (dispatch) {

  return bindActionCreators({
    FetchAssetById,
    SetPlayer,
    OpenMessage,
    SetSettingsState,
    AddToFavorites,
    RemoveFromFavorites,
    ShareRequestDone
  }, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(MovieProfile);



// WEBPACK FOOTER //
// ./src/components/ShowcaseCollection/Profile/Types/Movie/movie-profile.js